export function visitSeed() {
  try {let seed=sessionStorage.getItem('pa-visit-seed');if(!seed){seed=crypto.randomUUID();sessionStorage.setItem('pa-visit-seed',seed);}return seed;}catch{return crypto.randomUUID();}
}
